'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleLogger = function () {
    function SimpleLogger() {
        _classCallCheck(this, SimpleLogger);

        this.lastLog = undefined;
    }

    _createClass(SimpleLogger, [{
        key: 'includeProfiling',
        value: function includeProfiling(value) {
            if (value === undefined) {
                value = true;
            }

            this.lastLog = value ? new Date().getTime() : undefined;
        }
    }, {
        key: 'debug',
        value: function debug() {
            var _console;

            for (var _len = arguments.length, text = Array(_len), _key = 0; _key < _len; _key++) {
                text[_key] = arguments[_key];
            }

            (_console = console).log.apply(_console, [this.timestamp()].concat(text));
        }
    }, {
        key: 'warn',
        value: function warn() {
            var _console2;

            for (var _len2 = arguments.length, text = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                text[_key2] = arguments[_key2];
            }

            (_console2 = console).warn.apply(_console2, [this.timestamp()].concat(text));
        }
    }, {
        key: 'error',
        value: function error() {
            var _console3;

            for (var _len3 = arguments.length, text = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                text[_key3] = arguments[_key3];
            }

            (_console3 = console).error.apply(_console3, [this.timestamp()].concat(text));
        }
    }, {
        key: 'scream',
        value: function scream() {
            var _console4;

            var divider = '---------------------------------------------------------------------';

            console.error(this.timestamp(), divider);

            for (var _len4 = arguments.length, text = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                text[_key4] = arguments[_key4];
            }

            (_console4 = console).error.apply(_console4, [this.timestamp()].concat(text));
            console.error(this.timestamp(), divider);
        }

        // Implementation details ...

    }, {
        key: 'timestamp',
        value: function timestamp() {
            var now = new Date();
            var hour = this.leftPadWithZeros(now.getHours(), 2);
            var minute = this.leftPadWithZeros(now.getMinutes(), 2);
            var second = this.leftPadWithZeros(now.getSeconds(), 2);
            var millisecond = this.leftPadWithZeros(now.getMilliseconds(), 3);

            var ts = hour + ':' + minute + ':' + second + '.' + millisecond;

            if (this.lastLog) {
                ts += ' ' + this.elapsedText(now.getTime() - this.lastLog);

                this.lastLog = now.getTime();
            }

            return ts;
        }
    }, {
        key: 'elapsedText',
        value: function elapsedText(elapsed) {
            var ms = elapsed % 1000;
            var s = (elapsed - ms) / 1000;

            // We'll return something of the form "[01.234s]"

            var sText = this.leftPadWithZeros(s, 2);
            var msText = this.leftPadWithZeros(ms, 3);

            return '[' + sText + '.' + msText + 's]';
        }
    }, {
        key: 'leftPadWithZeros',
        value: function leftPadWithZeros(value, n) {
            var text = value.toString();

            while (text.length < n) {
                text = '0' + text;
            }

            return text;
        }
    }]);

    return SimpleLogger;
}();

module.exports = SimpleLogger;


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-resource/lib/simple-logger.js
// module id = 98
// module chunks = 4